module.exports = __webpack_public_path__ + "static/media/positiveImpactIcon.cd895f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/positiveImpactIcon.png
// module id = 899
// module chunks = 0